var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.846,
    height: 17.846,
    viewBox: "0 0 17.846 17.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "opted-out",
    transform: "translate(-52.999 -47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M65.618,64.846H58.226L53,59.619V52.227L58.226,47h7.392l5.227,5.227v7.392Z",
    transform: "translate(0 0)",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M122.725,80.872a.458.458,0,0,0-.128-.291.932.932,0,0,0-1.388-.009.461.461,0,0,0-.139.3v2.295a.3.3,0,0,1-.173.269h0a.3.3,0,0,1-.418-.269V76.63a.471.471,0,0,0-.121-.291.852.852,0,0,0-1.309,0,.471.471,0,0,0-.121.291v4.143a.307.307,0,0,1-.33.306h0a.307.307,0,0,1-.284-.306v-5.15a.478.478,0,0,0-.12-.289.914.914,0,0,0-1.333-.088.5.5,0,0,0-.188.351s0,3.967,0,5.079a.288.288,0,0,1-.287.288h-.007a.289.289,0,0,1-.292-.289V76.267a.478.478,0,0,0-.12-.289.914.914,0,0,0-1.333-.088.5.5,0,0,0-.188.351v4.584a.3.3,0,0,1-.277.3h-.008a.3.3,0,0,1-.321-.3V77.931a.479.479,0,0,0-.117-.291.814.814,0,0,0-1.267,0,.479.479,0,0,0-.117.291s0,8.555.008,8.593c.09,1.021,1.42,1.828,2.463,1.828h3.012a4.639,4.639,0,0,0,2.2-.557h0c1.138-.614,2.18-1.308,2.442-2.575a14.128,14.128,0,0,0,.259-2.515Z",
    transform: "translate(-55.167 -26.033)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptoutIcon);
export default __webpack_public_path__ + "static/media/optout-icon.0ecf5c55.svg";
export { ForwardRef as ReactComponent };